import { ProductCard } from "@components/ProductCard";
import { useProducts } from "@lib/hooks";

export function HomePage() {
  const { data, isLoading, isError } = useProducts();

  if (isLoading) {
    return <p>Loading products…</p>;
  }

  if (isError || !data) {
    return <p>Failed to load products. Try again later.</p>;
  }

  return (
    <div className="page home">
      <section className="hero">
        <h1>Product Intelligence</h1>
        <p>Research-backed product snapshots, reviews, and smart comparisons.</p>
      </section>
      <section className="products-grid">
        {data.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </section>
    </div>
  );
}
